<template>
    <div class="container">
        <el-button type="primary">Primaimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary weweimary wewery wewea</el-button>
        <el-input v-model="input" placeholder="Please input" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            input: ''
        }
    },
    mounted() {
        console.log("Component mounted.");
    },
};
</script>
